var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupprimerIconedark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    fill: "#4D5154",
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7083 33H18.9583C17.4585 33 16.25 31.7109 16.25 30.1111V18.1111H15.625C15.271 18.1111 15 17.822 15 17.4444V16.7778C15 16.4002 15.271 16.1111 15.625 16.1111H31.0417C31.3957 16.1111 31.6667 16.4002 31.6667 16.7778V17.4444C31.6667 17.822 31.3957 18.1111 31.0417 18.1111H30.4167V30.1111C30.4167 31.7109 29.2082 33 27.7083 33ZM26.25 21.2222H25.4167C25.0627 21.2222 24.7917 21.5113 24.7917 21.8889V28.5556C24.7917 28.9332 25.0627 29.2222 25.4167 29.2222H26.25C26.604 29.2222 26.875 28.9332 26.875 28.5556V21.8889C26.875 21.5113 26.604 21.2222 26.25 21.2222ZM21.25 21.2222H20.4167C20.0627 21.2222 19.7917 21.5113 19.7917 21.8889V28.5556C19.7917 28.9332 20.0627 29.2222 20.4167 29.2222H21.25C21.604 29.2222 21.875 28.9332 21.875 28.5556V21.8889C21.875 21.5113 21.604 21.2222 21.25 21.2222ZM25.625 15H21.0417C20.6877 15 20.4167 14.7109 20.4167 14.3333V13.6667C20.4167 13.2891 20.6877 13 21.0417 13H25.625C25.979 13 26.25 13.2891 26.25 13.6667V14.3333C26.25 14.7109 25.979 15 25.625 15Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupprimerIconedark);
export default __webpack_public_path__ + "static/media/supprimerIconedark.0efeec6431642482f730a21963998ab6.svg";
export { ForwardRef as ReactComponent };